import React from "react";

const formatName = (value) => {
  const text = String(value ?? "").trim();
  if (!text.includes("@")) return text;
  return text.split("@")[0]
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(" ");
};

const ResponseAttribution = ({ label, value }) => (
  <div className="Content-Small ain-history-attribution">
    {label}: <span className="ain-history-attribution-name">{formatName(value)}</span>
  </div>
);

export default ResponseAttribution;
